// src/services/api/login/tokenUtils.ts

import api from "../axiosConfig";

export const getAccessToken = (): string | null => {
  if (typeof window !== "undefined") {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) return accessToken;

    const rawUser = localStorage.getItem("user");
    try {
      if (!rawUser || rawUser === "undefined") return null;
      const parsedUser = JSON.parse(rawUser);
      return parsedUser?.accessToken || null;
    } catch (error) {
      console.error("Invalid user JSON in localStorage:", error);
      return null;
    }
  }
  return null;
};

export const getRefreshToken = (): string | null => {
  if (typeof window !== "undefined") {
    return localStorage.getItem("refreshToken");
  }
  return null;
};

export const refreshToken = async (): Promise<string | null> => {
  const currentRefreshToken = localStorage.getItem("refreshToken");
  if (!currentRefreshToken) {
    return null;
  }

  try {
    const response = await api.post("/auth/refresh-token", {
      refreshToken: currentRefreshToken,
    });

    const { accessToken, refreshToken: newRefreshToken } = response.data;
    localStorage.setItem("accessToken", accessToken);

    const rawUser = localStorage.getItem("user");
    if (rawUser && rawUser !== "undefined") {
      try {
        const userObj = JSON.parse(rawUser);
        userObj.accessToken = accessToken;
        localStorage.setItem("user", JSON.stringify(userObj));
      } catch {}
    }

    if (newRefreshToken) {
      localStorage.setItem("refreshToken", newRefreshToken);
    }

    api.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
    return accessToken;
  } catch (error) {
    console.error("Failed to refresh token:", error);
    return null;
  }
};

export const logout = async () => {
  const refreshToken = localStorage.getItem("refreshToken");
  try {
    if (refreshToken) {
      await api.post("/auth/logout", { refreshToken });
    }
  } catch (error) {
    console.error("Logout API failed:", error);
  }
  localStorage.removeItem("user");
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  delete api.defaults.headers.common["Authorization"];
  if (typeof window !== "undefined") {
    window.location.href = "/login";
  }
};
